import React, {useContext, useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from "react-intl";
import DesktopPopup from "../../../../../../components/WMS/Desktop/Popup";
import {createAssociation, getAddAssociationData, patchAssociation} from "../../../call&logic/logicAndCall";
import {Grid} from "@mui/material";
import FormControlLabel from "../../../../../../components/radioGroup/FormControlLabel";
import RadioGroup from "../../../../../../components/radioGroup/RadioGroup";
import {getTranslation} from "../../../../../../domain/helpers/translations";
import CustomButton from "../../../../../../components/CustomButton";
import DualChoiceList from './DualChoiceList';
import SelectTitle from "../../../../../../components/radioGroup/SelectTitle";
import {WMSContext} from "../../../../context/WMSContext";
import CategoriesSelector from "./CategoriesSelector";

AssociationModal.propTypes = {
    open: PropTypes.bool.isRequired,
    handleClose: PropTypes.func.isRequired,
    association: PropTypes.object
};

function AssociationModal({open, handleClose, association = null}) {
    const {currentInventory} = useContext(WMSContext)

    const [categories, setCategories] = useState([])
    const [brands, setBrands] = useState([])
    const [places, setPlaces] = useState([])
    const [retailers, setRetailers] = useState([])

    const [selectedBrand, setSelectedBrand] = useState()
    const [selectedCategory, setSelectedCategory] = useState()
    const [selectedRetailer, setSelectedRetailer] = useState()
    const [selectedFirstPlace, setSelectedFirstPlace] = useState()
    const [selectedSecondPlace, setSelectedSecondPlace] = useState()

    const [isValid, setIsValid] = useState(false)

    const handleSelectBrand = (id) => {
        setSelectedBrand(brands.find(brand => brand.id === id))
    }

    const handleSelectRetailer = (id) => {
        setSelectedRetailer(retailers.find(retailer => retailer.id === id))
    }

    const handleSelectCategory = (id) => {
        setSelectedCategory(categories.find(category => category.id === id))
    }

    const handleValid = () => {
        if (!association) {
            createAssociation(currentInventory.id, selectedBrand?.id, selectedRetailer?.id, selectedCategory?.id, selectedFirstPlace, selectedSecondPlace).then(r => {
                handleClose(true, 'create')
            })
        } else {
            patchAssociation(association.id, currentInventory.id, selectedBrand?.id, selectedRetailer?.id, selectedCategory?.id, selectedFirstPlace, selectedSecondPlace).then(r => {
                handleClose(true, 'modify')
            })
        }

    }

    useEffect(() => {
        if (currentInventory) {
            getAddAssociationData(currentInventory.id).then(response => {
                if (association) {
                    if (association.category && association.category.translations) {
                        association.category = {
                            ...association.category,
                            id: association.category.id,
                            name: getTranslation(association.category).name
                        }
                    }
                    setSelectedFirstPlace(association.firstPlace)
                    setSelectedBrand(association.brand)
                    setSelectedRetailer(association.seller)
                    setSelectedCategory(association.category)
                    setSelectedSecondPlace(association.secondPlace)
                }

                setBrands(response.brands)
                setCategories(response.categories)
                setPlaces(response.places)
                setRetailers(response.retailers)
            })
        }
    }, [currentInventory]);

    useEffect(() => {
        if ((selectedBrand || selectedRetailer || selectedCategory) && selectedFirstPlace) {
            setIsValid(true)
        } else {
            setIsValid(false)
        }

    }, [selectedBrand, selectedRetailer, selectedCategory, selectedFirstPlace]);
    return (
        <>
            {open && categories.length > 0 && brands.length > 0 && places.length > 0 && (
                <DesktopPopup
                    open={open}
                    onClose={handleClose}
                    title={<FormattedMessage id={"wms.associations.add.title"}/>}
                    subtitle={<FormattedMessage id={'wms.associations.add.subtitle'}/>}
                    position={'relative'}
                    overflow={'auto'}
                >
                    <Grid container direction={"column"} gap={"24px"}>

                        <Grid container direction={"column"}>
                            <SelectTitle titleTranslationKey={"wms.associations.add.brandChoice"}/>
                            <RadioGroup
                                alignListWithButton
                                selectedValueLabel={selectedBrand?.name}
                                value={selectedBrand?.id ?? null}
                                placeholder={<FormattedMessage id={"wms.associations.add.brandChoicePlaceholder"}/>}
                                onChange={(event) => {
                                    handleSelectBrand(event.currentTarget.value)
                                }}
                            >
                                {brands.map((brand, index) => (
                                    <FormControlLabel
                                        key={index}
                                        value={brand.id}
                                        label={brand.name}
                                    />
                                ))}
                            </RadioGroup>
                        </Grid>

                        <Grid container direction={"column"}>
                            <SelectTitle titleTranslationKey={"wms.associations.add.sellerChoice"}/>
                            <RadioGroup
                                alignListWithButton
                                selectedValueLabel={selectedRetailer?.name}
                                value={selectedRetailer?.id ?? null}
                                placeholder={<FormattedMessage id={"wms.associations.add.sellerChoicePlaceholder"}/>}
                                onChange={(event) => {
                                    handleSelectRetailer(event.currentTarget.value)
                                }}
                            >
                                {retailers.map((retailer, index) => (
                                    <FormControlLabel
                                        key={index}
                                        value={retailer.id}
                                        label={retailer.name}
                                    />
                                ))}
                            </RadioGroup>
                        </Grid>

                        <Grid container direction={"column"}>
                            <SelectTitle titleTranslationKey={"wms.associations.add.categoryChoice"}/>
                            <CategoriesSelector
                                categories={categories}
                                selectedCategory={selectedCategory}
                                onSelectedCategory={setSelectedCategory}
                            />
                        </Grid>

                        <DualChoiceList
                            items={places.map(place => ({
                                ...place,
                                isSelectedFirst: false,
                                isSelectedSecond: false
                            }))}
                            firstTitle={<FormattedMessage id={"wms.associations.add.placeChoiceFirst"}/>}
                            secondTitle={<FormattedMessage id={"wms.associations.add.placeChoiceSecond"}/>}
                            setFirstChoice={setSelectedFirstPlace}
                            setSecondChoice={setSelectedSecondPlace}
                            selectedAssociation={association}
                        />

                        <Grid container gap={"8px"} justifyContent={"end"}>
                            <CustomButton variant={"nude"} color={"default"} onClick={() => handleClose()}><FormattedMessage id={"wms.associations.add.cancel"}/></CustomButton>
                            <CustomButton disabled={!isValid} onClick={handleValid}><FormattedMessage id={"wms.associations.add.create"}/></CustomButton>
                        </Grid>
                    </Grid>
                </DesktopPopup>
            )}
        </>
    );
}

export default AssociationModal;